// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ii-0";
export var animationContainer = "_ii-1";
export var itemPrice = "_ii-a";
export var itemizedContent = "_ii-9";
export var itemizedHeader = "_ii-7";
export var itemizedRow = "_ii-8";
export var itemizedSection = "_ii-6";
export var modalContent = "_ii-2";
export var orderName = "_ii-3";
export var refundOption = "_ii-4";
export var refundOptionsContainer = "_ii-5";
export var shippingLabel = "_ii-b";
export var totalRow = "_ii-c";